import Mom from './Mom';

export default Mom;